/* assets/build-set.js */
/* Varianta: fara slide cart. La "Adauga setul in cos" -> redirect direct in cart, cu discount aplicat garantat. */

(function () {
  const root = document.querySelector(".build-set");
  if (!root) return;

  const dataEl = root.querySelector(".js-build-set-data");
  if (!dataEl) return;

  let models = [];
  try {
    models = JSON.parse(dataEl.textContent || "[]");
  } catch (e) {
    console.error("Build-set: JSON invalid în js-build-set-data", e);
    return;
  }

  const getAttr = (name) => (dataEl.getAttribute(name) || "").toString();

  const freeShippingThreshold = parseInt(getAttr("data-free-shipping") || "0", 10);

  const discountCodes = {
    2: getAttr("data-code-2").trim(),
    3: getAttr("data-code-3").trim(),
    4: getAttr("data-code-4").trim(),
  };

  const pcts = {
    2: parseFloat(getAttr("data-pct-2") || "5"),
    3: parseFloat(getAttr("data-pct-3") || "8"),
    4: parseFloat(getAttr("data-pct-4") || "12"),
  };

  const els = {
    modelSearch: root.querySelector(".js-model-search"),
    modelChips: root.querySelector(".js-model-chips"),
    pillsWrap: root.querySelector(".js-category-pills"),
    onlyModel: root.querySelector(".js-only-model"),
    grid: root.querySelector(".js-products-grid"),

    setItems: root.querySelector(".js-set-items"),
    subtotal: root.querySelector(".js-subtotal"),
    discount: root.querySelector(".js-discount"),
    total: root.querySelector(".js-total"),
    discountNote: root.querySelector(".js-discount-note"),

    clearSet: root.querySelector(".js-clear-set"),
    addSet: root.querySelector(".js-add-set"),

    discountBar: root.querySelector(".js-set-discount-bar"),
    discountLabel: root.querySelector(".js-set-discount-label"),
    discountMeta: root.querySelector(".js-set-discount-meta"),

    shipBar: root.querySelector(".js-free-ship-bar"),
    shipMeta: root.querySelector(".js-free-ship-meta"),
  };

  const state = {
    selectedModelId: null, // null = Toate modelele
    search: "",
    category: "all",
    onlyModel: false, // implicit debifat (ramane in UI, dar filtrarea pe model se face oricum)
    set: new Map(), // variantId -> {variantId,title,url,image,price,qty}
    cartQty: new Map(), // variantId -> qty în coș
  };

  const delay = (ms) => new Promise((r) => setTimeout(r, ms));

  // -------- Locale helpers (RO/EN) --------
  const getLocale = () => {
    const htmlLang = (document.documentElement.getAttribute("lang") || "").toLowerCase();
    const shopifyLocale =
      window.Shopify && (window.Shopify.locale || window.Shopify.language)
        ? String(window.Shopify.locale || window.Shopify.language).toLowerCase()
        : "";
    return (htmlLang || shopifyLocale || "ro").trim();
  };

  const isEnglish = () => {
    const loc = getLocale();
    return loc === "en" || loc.startsWith("en-");
  };

  const LABEL_SIZE = () => (isEnglish() ? "Size" : "Mărime");

  // -------- i18n text helpers --------
  const TXT = {
    all: () => isEnglish() ? "All" : "Toate",
    addToSet: () => isEnglish() ? "Add to set" : "Adaugă în set",
    soldOut: () => isEnglish() ? "Sold out" : "Stoc epuizat",
    addSetToCart: () => isEnglish() ? "Add set to cart" : "Adaugă setul în coș",
    emptySet: () => isEnglish() ? "Add pieces to your set." : "Adaugă piese în set.",
    noProducts: () => isEnglish() ? "No products found in this category." : "Nu am găsit produse în această categorie.",
    noModels: () => isEnglish() ? "No models configured." : "Nu există modele configurate.",
    clearSet: () => isEnglish() ? "Clear" : "Golește",
    add2pieces: () => isEnglish() ? "Add 2+ pieces" : "Adaugă 2+ piese",
    pieces: (n) => isEnglish() ? `${n} pieces` : `${n} piese`,
    discountActive: (pct, code) => isEnglish() ? `Active discount: ${pct}% (code ${code})` : `Reducere activă: ${pct}% (cod ${code})`,
    discountNote: () => isEnglish() ? "Set discount is applied automatically in cart." : "Reducerea de set se aplică automat în coș.",
    discountNoteMin: () => isEnglish() ? "Add at least 2 pieces to activate the set discount." : "Adaugă minim 2 piese ca să activezi reducerea de set.",
    freeShipDone: () => isEnglish() ? "You have free shipping." : "Ai transport gratuit.",
    freeShipRemaining: (amount) => isEnglish() ? `You need ${amount} more for free shipping.` : `Îți mai lipsesc ${amount} pentru transport gratuit.`,
    unavailable: () => isEnglish() ? "Product unavailable." : "Produs indisponibil.",
    stockLimit: () => isEnglish() ? "Limited availability. You cannot add another unit of this product." : "Disponibilitate limitată. Nu mai poți adăuga încă o unitate din acest produs.",
    stockLimitCart: (n) => isEnglish() ? `Limited availability. Only ${n} item(s) can be added to cart.` : `Disponibilitate limitată. Doar ${n} articol(e) poate/pot fi adăugat(e) în coș din cauza disponibilității.`,
    cartErrorDetail: (msg) => isEnglish() ? `Could not add set to cart. Detail: ${msg}` : `Nu am putut adăuga setul în coș. Detaliu: ${msg}`,
    addEmptyWarning: () => isEnglish() ? "Add products to the set before continuing." : "Adaugă produse în set înainte să continui.",
    previewLabel: () => isEnglish() ? "Preview product" : "Previzualizează produsul",
    closeLabel: () => isEnglish() ? "Close" : "Închide",
    prevImage: () => isEnglish() ? "Previous image" : "Imaginea anterioară",
    nextImage: () => isEnglish() ? "Next image" : "Imaginea următoare",
    sizeGuide: () => isEnglish() ? "Ring size guide" : "Ghid de mărimi",
  };

  // -------- Toast --------
  let toastTimer = null;
  const toast = (message) => {
    if (!message) return;

    let el = document.querySelector(".build-set__toast");
    if (!el) {
      el = document.createElement("div");
      el.className = "build-set__toast";
      el.setAttribute("role", "status");
      el.setAttribute("aria-live", "polite");

      el.style.position = "fixed";
      el.style.left = "50%";
      el.style.bottom = "18px";
      el.style.transform = "translateX(-50%)";
      el.style.zIndex = "9999";
      el.style.maxWidth = "92vw";
      el.style.padding = "10px 14px";
      el.style.borderRadius = "10px";
      el.style.fontSize = "14px";
      el.style.lineHeight = "1.2";
      el.style.background = "rgba(17,17,17,0.95)";
      el.style.color = "#fff";
      el.style.boxShadow = "0 10px 30px rgba(0,0,0,0.22)";
      el.style.opacity = "0";
      el.style.transition = "opacity 160ms ease";

      document.body.appendChild(el);
    }

    el.textContent = message;
    el.style.display = "block";
    void el.offsetHeight;
    el.style.opacity = "1";

    if (toastTimer) clearTimeout(toastTimer);
    toastTimer = setTimeout(() => {
      el.style.opacity = "0";
      setTimeout(() => {
        el.style.display = "none";
      }, 200);
    }, 3200);
  };

  const money = (cents) => {
    const value = (cents / 100).toFixed(2).replace(".", ",");
    return `${value} lei`;
  };

  const normalize = (s) => (s || "").toLowerCase().trim();

  // -------- Category detection RO + EN (robust, fără "earrings" -> "ring") --------
  const getCategory = (product) => {
    const pt = normalize(product.product_type || "");
    const title = normalize(product.title || "");
    const t = `${pt} ${title}`.trim();

    // 1) Preferăm product_type (stabil, nu depinde de limbă)
    if (pt) {
      if (pt.includes("inel") || pt.includes("inele") || pt.includes("ring") || pt.includes("rings")) return "rings";
      if (pt.includes("cercei") || pt.includes("earring") || pt.includes("earrings")) return "earrings";
      if (
        pt.includes("brat") ||
        pt.includes("brăț") ||
        pt.includes("bratara") ||
        pt.includes("brătară") ||
        pt.includes("bratari") ||
        pt.includes("brățări") ||
        pt.includes("bracelet") ||
        pt.includes("bracelets")
      )
        return "bracelets";
      if (pt.includes("colier") || pt.includes("coliere") || pt.includes("necklace") || pt.includes("necklaces"))
        return "necklaces";
    }

    // 2) Fallback pe title cu regex pe cuvinte (evită "earrings" să prindă "ring")
    const has = (re) => re.test(title);

    if (has(/\bearrings?\b/)) return "earrings";
    if (has(/\bbracelets?\b/)) return "bracelets";
    if (has(/\bnecklaces?\b/)) return "necklaces";
    if (has(/\brings?\b/)) return "rings";

    // 3) Fallback RO (dacă title e în română)
    if (t.includes("cercei")) return "earrings";
    if (t.includes("brăț") || t.includes("brat") || t.includes("bratara") || t.includes("brătară") || t.includes("bratari") || t.includes("brățări")) return "bracelets";
    if (t.includes("colier") || t.includes("coliere")) return "necklaces";
    if (t.includes("inel") || t.includes("inele")) return "rings";

    return "all";
  };

  const isRing = (product) => getCategory(product) === "rings";

  const selectedModel = () => models.find((m) => m.id === state.selectedModelId) || null;

  const bestTier = (piecesCount) => {
    if (piecesCount >= 4) return 4;
    if (piecesCount >= 3) return 3;
    if (piecesCount >= 2) return 2;
    return 0;
  };

  // -------- Indexuri --------
  const productByHandle = new Map();
  const variantIndex = new Map();

  const buildIndexes = () => {
    productByHandle.clear();
    variantIndex.clear();

    (models || []).forEach((m) => {
      (m.components || []).forEach((p) => {
        if (p?.handle) productByHandle.set(String(p.handle), p);

        (p.variants || []).forEach((v) => {
          const id = parseInt(v?.id || "0", 10);
          if (!id) return;
          variantIndex.set(id, { ...v, _productTitle: p.title, _productHandle: p.handle });
        });
      });
    });
  };

  const getVariantStockLimit = (variant) => {
    if (!variant) return Infinity;

    const mgmt = variant.inventory_management;
    const policy = (variant.inventory_policy || "").toString();

    if (!mgmt) return Infinity;
    if (policy === "continue") return Infinity;

    const q = parseInt(variant.inventory_quantity || "0", 10);
    if (Number.isNaN(q)) return 0;
    return Math.max(0, q);
  };

  const qtyInSet = (variantId) => {
    const it = state.set.get(variantId);
    return it ? it.qty : 0;
  };

  const qtyInCart = (variantId) => state.cartQty.get(variantId) || 0;

  const remainingAddableInBuilder = (variantId) => {
    const v = variantIndex.get(variantId);
    const limit = getVariantStockLimit(v);
    if (limit === Infinity) return Infinity;

    const used = qtyInSet(variantId) + qtyInCart(variantId);
    return Math.max(0, limit - used);
  };

  const refreshCartQuantities = async () => {
    try {
      const res = await fetch("/cart.js", { credentials: "same-origin", cache: "no-store" });
      if (!res.ok) return null;
      const cart = await res.json();

      state.cartQty.clear();
      (cart.items || []).forEach((it) => {
        const id = parseInt(it.variant_id || "0", 10);
        const q = parseInt(it.quantity || "0", 10);
        if (id) state.cartQty.set(id, q);
      });

      const bubble = document.querySelector("#cart-icon-bubble .cart-count-bubble span[aria-hidden='true']");
      const bubbleWrap = document.querySelector("#cart-icon-bubble .cart-count-bubble");
      if (bubble && bubbleWrap) {
        const count = parseInt(cart.item_count || "0", 10) || 0;
        bubble.textContent = String(count);
        bubbleWrap.style.display = count > 0 ? "" : "none";
      }

      return cart;
    } catch (e) {
      return null;
    }
  };

  // -------- Modal --------
  const productCache = new Map();

  const ensureSizedImage = (url, w) => {
    if (!url) return url;
    const width = w || 900;
    const hasQuery = url.includes("?");
    return url + (hasQuery ? `&width=${width}` : `?width=${width}`);
  };

  const fetchProductDetails = async (handle) => {
    const key = String(handle || "");
    if (!key) return null;
    if (productCache.has(key)) return productCache.get(key);

    const res = await fetch(`/products/${encodeURIComponent(key)}.js`, {
      credentials: "same-origin",
      cache: "no-store",
    });
    if (!res.ok) return null;
    const data = await res.json();

    const images = (data.images || []).map((u) => ensureSizedImage(u, 900));
    const variants = data.variants || [];

    const packed = { images, variants };
    productCache.set(key, packed);
    return packed;
  };

  let modal = null;
  let modalState = {
    handle: "",
    images: [],
    index: 0,
    variantId: 0,
  };

  const buildModal = () => {
    if (modal) return modal;

    const wrap = document.createElement("div");
    wrap.className = "build-set__modal";
    wrap.setAttribute("aria-hidden", "true");

    wrap.innerHTML = `
      <div class="build-set__modal-dialog" role="dialog" aria-modal="true" aria-label="${TXT.previewLabel()}">
        <button class="build-set__modal-close js-modal-close" type="button" aria-label="${TXT.closeLabel()}">×</button>

        <div class="build-set__modal-media">
          <button class="build-set__modal-arrow is-left js-modal-prev" type="button" aria-label="${TXT.prevImage()}">‹</button>
          <img class="js-modal-img" alt="" loading="eager">
          <button class="build-set__modal-arrow is-right js-modal-next" type="button" aria-label="${TXT.nextImage()}">›</button>
        </div>

        <div class="build-set__modal-content">
          <div class="build-set__modal-variant js-modal-variant"></div>
          <div class="build-set__modal-actions">
            <button class="button button--secondary build-set__add js-modal-add" type="button">${TXT.addToSet()}</button>
          </div>
        </div>
      </div>
    `;

    document.body.appendChild(wrap);
    modal = wrap;

    const dialog = modal.querySelector(".build-set__modal-dialog");

    modal.addEventListener("click", (e) => {
      if (e.target === modal) closeModal();
    });

    if (dialog) dialog.addEventListener("click", (e) => e.stopPropagation());

    modal.querySelector(".js-modal-close")?.addEventListener("click", closeModal);

    modal.querySelector(".js-modal-prev")?.addEventListener("click", () => {
      if (!modalState.images.length) return;
      modalState.index = (modalState.index - 1 + modalState.images.length) % modalState.images.length;
      updateModalImage();
    });

    modal.querySelector(".js-modal-next")?.addEventListener("click", () => {
      if (!modalState.images.length) return;
      modalState.index = (modalState.index + 1) % modalState.images.length;
      updateModalImage();
    });

    modal.querySelector(".js-modal-add")?.addEventListener("click", () => {
      const select = modal.querySelector(".js-modal-variant-select");
      const variantId = parseInt(select?.value || String(modalState.variantId || "0"), 10);
      if (!variantId) return;

      const v = variantIndex.get(variantId);
      if (v && v.available === false) {
        toast(TXT.unavailable());
        return;
      }

      const remaining = remainingAddableInBuilder(variantId);
      if (remaining <= 0) {
        toast(TXT.stockLimit());
        return;
      }

      const p = productByHandle.get(modalState.handle);
      if (!p) return;

      const title = p.title || v?._productTitle || "Produs";
      const url = p.url || "";
      const image = p.image || "";
      const price = v ? parseInt(v.price || "0", 10) : 0;

      const existing = state.set.get(variantId);
      if (existing) {
        existing.qty += 1;
        state.set.set(variantId, existing);
      } else {
        state.set.set(variantId, { variantId, title, url, image, price, qty: 1 });
      }

      renderSet();
      closeModal();
    });

    document.addEventListener("keydown", (e) => {
      if (!modal || !modal.classList.contains("is-open")) return;
      if (e.key === "Escape") closeModal();
    });

    return modal;
  };

  const updateModalImage = () => {
    if (!modal) return;

    const img = modal.querySelector(".js-modal-img");
    const prev = modal.querySelector(".js-modal-prev");
    const next = modal.querySelector(".js-modal-next");

    const images = modalState.images || [];
    const hasMany = images.length > 1;

    if (img) {
      img.src = images[modalState.index] || "";
      img.alt = "";
    }

    if (prev) prev.disabled = !hasMany;
    if (next) next.disabled = !hasMany;
  };

  const pickDefaultVariant = (product) => {
    const v = (product.variants || []).find((x) => x.available) || product.variants?.[0];
    return v || null;
  };

  const openModal = async ({ handle, initialVariantId }) => {
    if (!handle) return;

    buildModal();

    modalState.handle = handle;
    modalState.index = 0;
    modalState.variantId = parseInt(initialVariantId || "0", 10) || 0;
    modalState.images = [];

    document.documentElement.classList.add("build-set--modal-open");
    document.body.classList.add("build-set--modal-open");

    modal.classList.add("is-open");
    modal.setAttribute("aria-hidden", "false");

    const p = productByHandle.get(handle);
    const fallbackImage = p?.image ? [ensureSizedImage(p.image, 900)] : [];

    // Update modal add button based on product availability
    const modalAddBtn = modal.querySelector(".js-modal-add");
    const productIsAvailable = !p || (p.available !== false && (p.variants || []).some(v => v.available));
    if (modalAddBtn) {
      if (productIsAvailable) {
        modalAddBtn.disabled = false;
        modalAddBtn.textContent = TXT.addToSet();
        modalAddBtn.classList.remove("build-set__add--sold-out");
      } else {
        modalAddBtn.disabled = true;
        modalAddBtn.textContent = TXT.soldOut();
        modalAddBtn.classList.add("build-set__add--sold-out");
      }
    }

    const mount = modal.querySelector(".js-modal-variant");
    if (mount) {
      const ring = p ? isRing(p) : false;
      const availableVariants = (p?.variants || []).filter((v) => v.available);
      const variantsForSelect = availableVariants.length ? availableVariants : (p?.variants || []);
      const shouldShowSelect = ring || variantsForSelect.length > 1;

      const chosenDefault = modalState.variantId
        ? (variantsForSelect || []).find((x) => parseInt(x.id, 10) === modalState.variantId)
        : p
          ? pickDefaultVariant(p)
          : null;

      modalState.variantId = chosenDefault ? parseInt(chosenDefault.id, 10) : modalState.variantId;

      if (shouldShowSelect && variantsForSelect.length) {
        mount.innerHTML = `
          <label>
            <span>${LABEL_SIZE()}</span>
            <select class="js-modal-variant-select">
              ${variantsForSelect
                .map((v) => {
                  const sel = modalState.variantId && parseInt(v.id, 10) === modalState.variantId ? "selected" : "";
                  return `<option value="${v.id}" ${sel}>${v.title}</option>`;
                })
                .join("")}
            </select>
          </label>
        `;
      } else {
        mount.innerHTML = ``;
      }
    }

    try {
      const details = await fetchProductDetails(handle);
      const imgs = (details?.images || []).filter(Boolean);
      modalState.images = imgs.length ? imgs : fallbackImage;
    } catch (e) {
      modalState.images = fallbackImage;
    }

    updateModalImage();
  };

  const closeModal = () => {
    if (!modal) return;
    modal.classList.remove("is-open");
    modal.setAttribute("aria-hidden", "true");

    document.documentElement.classList.remove("build-set--modal-open");
    document.body.classList.remove("build-set--modal-open");
  };

  // -------- Render --------
  const renderModelChips = () => {
    if (!els.modelChips) return;

    const q = normalize(state.search);
    const filtered = (models || []).filter((m) => normalize(m.title).includes(q));

    const allActive = state.selectedModelId == null ? "is-active" : "";

    els.modelChips.innerHTML = `
      <button type="button" class="build-set__chip ${allActive}" data-model="all">
        <span class="build-set__chip-text">${TXT.all()}</span>
      </button>
      ${filtered
        .map((m) => {
          const active = m.id === state.selectedModelId ? "is-active" : "";
          return `<button type="button" class="build-set__chip ${active}" data-model="${m.id}">
            <span class="build-set__chip-text">${m.title}</span>
          </button>`;
        })
        .join("")}
    `;

    els.modelChips.querySelectorAll("[data-model]").forEach((btn) => {
      btn.addEventListener("click", () => {
        const v = btn.dataset.model;
        state.selectedModelId = v === "all" ? null : parseInt(v, 10);
        renderAll();
      });
    });
  };

  const renderPills = () => {
    if (!els.pillsWrap) return;
    els.pillsWrap.querySelectorAll(".build-set__pill").forEach((b) => {
      b.classList.toggle("is-active", b.dataset.category === state.category);
    });
  };

  // IMPORTANT: alegerea modelului filtreaza mereu.
  // "Toate" la modele (selectedModelId = null) este singura varianta care arata tot.
  const getGridItems = () => {
    const items =
      state.selectedModelId == null
        ? (models || []).flatMap((m) => m.components || [])
        : (selectedModel()?.components || []);

    return items.filter((p) => {
      if (state.category !== "all" && getCategory(p) !== state.category) return false;
      return true;
    });
  };

  const renderGrid = () => {
    if (!els.grid) return;

    if (!models || !models.length) {
      els.grid.innerHTML = `<div class="build-set__empty">${TXT.noModels()}</div>`;
      return;
    }

    const filtered = getGridItems();
    if (!filtered.length) {
      els.grid.innerHTML = `<div class="build-set__empty">${TXT.noProducts()}</div>`;
      return;
    }

    els.grid.innerHTML = filtered
      .map((p) => {
        const ring = isRing(p);
        const defaultVariant = pickDefaultVariant(p);
        const isAvailable = p.available !== false && (p.variants || []).some(v => v.available);

        const availableVariants = (p.variants || []).filter((v) => v.available);
        const variantsForSelect = availableVariants.length ? availableVariants : (p.variants || []);

        const variantSelect = ring
          ? `<label class="build-set__variant">
              <span>${LABEL_SIZE()}</span>
              <select class="js-variant">
                ${variantsForSelect
                  .map((v) => {
                    const selected = defaultVariant && v.id === defaultVariant.id ? "selected" : "";
                    return `<option value="${v.id}" ${selected}>${v.title}</option>`;
                  })
                  .join("")}
              </select>
            </label>`
          : `<input type="hidden" class="js-variant" value="${defaultVariant ? defaultVariant.id : ""}" />`;

        const priceCents = defaultVariant ? parseInt(defaultVariant.price || "0", 10) : 0;

        return `<article class="build-set__card" data-handle="${p.handle || ""}">
          <button class="build-set__img js-open-modal" type="button" aria-label="${TXT.previewLabel()}">
            <img src="${p.image}" alt="${p.title}" loading="lazy">
            ${!isAvailable ? `<span class="build-set__sold-badge">${TXT.soldOut()}</span>` : ''}
          </button>

          <div class="build-set__card-body">
            <button class="build-set__name js-open-modal" type="button">${p.title}</button>
            <div class="build-set__price">${money(priceCents)}</div>
            ${variantSelect}

            ${isAvailable
              ? `<button class="button button--secondary build-set__add js-add" type="button"
                  data-title="${encodeURIComponent(p.title)}"
                  data-url="${encodeURIComponent(p.url)}"
                  data-image="${encodeURIComponent(p.image)}">
                  ${TXT.addToSet()}
                </button>`
              : `<button class="button button--secondary build-set__add build-set__add--sold-out" type="button" disabled>${TXT.soldOut()}</button>`
            }
          </div>
        </article>`;
      })
      .join("");
  };

  const renderSet = () => {
    if (!els.setItems) return;

    const items = Array.from(state.set.values());

    if (!items.length) {
      els.setItems.innerHTML = `<div class="build-set__empty">${TXT.emptySet()}</div>`;
    } else {
      els.setItems.innerHTML = items
        .map((it) => {
          return `<div class="build-set__set-item">
            <img class="build-set__set-img" src="${it.image}" alt="${it.title}" loading="lazy">
            <div class="build-set__set-info">
              <div class="build-set__set-title">${it.title}</div>
              <div class="build-set__set-meta">${money(it.price)} · x${it.qty}</div>
            </div>
            <button class="build-set__remove js-remove" data-variant="${it.variantId}" type="button">✕</button>
          </div>`;
        })
        .join("");
    }

    const piecesCount = items.reduce((acc, it) => acc + it.qty, 0);
    const subtotal = items.reduce((acc, it) => acc + it.price * it.qty, 0);

    const tier = bestTier(piecesCount);
    const pct = tier ? pcts[tier] : 0;
    const discount = Math.round((subtotal * pct) / 100);
    const total = subtotal - discount;

    if (els.subtotal) els.subtotal.textContent = money(subtotal);
    if (els.discount) els.discount.textContent = tier ? `-${money(discount)}` : money(0);
    if (els.total) els.total.textContent = money(total);

    if (els.discountNote) {
      els.discountNote.textContent = tier
        ? TXT.discountNote()
        : TXT.discountNoteMin();
    }

    if (els.discountBar) {
      const pctBar = (Math.min(piecesCount, 4) / 4) * 100;
      els.discountBar.style.width = `${pctBar}%`;
    }

    if (els.discountLabel) {
      els.discountLabel.textContent = piecesCount >= 2 ? TXT.pieces(piecesCount) : TXT.add2pieces();
    }

    if (els.discountMeta) {
      if (tier) {
        els.discountMeta.textContent = TXT.discountActive(pcts[tier], discountCodes[tier] || "");
      } else {
        els.discountMeta.textContent = ``;
      }
    }

    if (els.shipBar) {
      const max = Math.max(1, freeShippingThreshold);
      const fill = Math.min(100, (subtotal / max) * 100);
      els.shipBar.style.width = `${fill}%`;
    }

    if (els.shipMeta) {
      if (!freeShippingThreshold) {
        els.shipMeta.textContent = "";
      } else if (subtotal >= freeShippingThreshold) {
        els.shipMeta.textContent = TXT.freeShipDone();
      } else {
        const remaining = freeShippingThreshold - subtotal;
        els.shipMeta.textContent = TXT.freeShipRemaining(money(remaining));
      }
    }
  };

  // -------- Add set to cart --------
  const addSetFlow = async () => {
    const items = Array.from(state.set.values());
    if (!items.length) {
      toast(TXT.addEmptyWarning());
      return;
    }

    if (els.addSet) {
      els.addSet.disabled = true;
      els.addSet.setAttribute("aria-busy", "true");
    }

    try {
      await refreshCartQuantities();

      for (const it of items) {
        const v = variantIndex.get(it.variantId);
        const limit = getVariantStockLimit(v);
        if (limit === Infinity) continue;

        const inCart = qtyInCart(it.variantId);
        const availableToAdd = Math.max(0, limit - inCart);

        if (it.qty > availableToAdd) {
          toast(TXT.stockLimitCart(availableToAdd));
          return;
        }
      }

      const piecesCount = items.reduce((acc, it) => acc + it.qty, 0);
      const tier = bestTier(piecesCount);
      const code = tier ? discountCodes[tier] : "";

      const payload = { items: items.map((it) => ({ id: it.variantId, quantity: it.qty })) };

      const res = await fetch(`/cart/add.js`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
        credentials: "same-origin",
      });

      if (!res.ok) {
        let msg = "Eroare";
        try {
          const j = await res.json();
          msg = j?.description || j?.message || msg;
        } catch (e) {}
        toast(TXT.cartErrorDetail(msg));
        return;
      }

      await delay(150);

      const rootPath = window.Shopify?.routes?.root || "/"; // suportă și /en/
      const redirectTo = `${rootPath}cart`;

      if (tier && code) {
        window.location.href = `${rootPath}discount/${encodeURIComponent(code)}?redirect=${encodeURIComponent(
          redirectTo
        )}`;
      } else {
        window.location.href = redirectTo;
      }
      return;
    } catch (e) {
      const msg = e && e.message ? String(e.message) : "Eroare";
      toast(TXT.cartErrorDetail(msg));
    } finally {
      if (els.addSet) {
        els.addSet.disabled = false;
        els.addSet.removeAttribute("aria-busy");
      }
    }
  };

  // -------- Handlers --------
  const onGridClick = (e) => {
    const openBtn = e.target.closest(".js-open-modal");
    if (openBtn) {
      const card = openBtn.closest(".build-set__card");
      const handle = card?.dataset?.handle || "";
      const select = card?.querySelector(".js-variant");
      const variantId = parseInt(select?.value || "0", 10);
      openModal({ handle, initialVariantId: variantId });
      return;
    }

    const addBtn = e.target.closest(".js-add");
    if (addBtn) {
      const card = addBtn.closest(".build-set__card");
      const select = card.querySelector(".js-variant");
      const variantId = parseInt(select?.value || "0", 10);
      if (!variantId) return;

      const variant = variantIndex.get(variantId);
      if (variant && variant.available === false) {
        toast(TXT.unavailable());
        return;
      }

      const remaining = remainingAddableInBuilder(variantId);
      if (remaining <= 0) {
        toast(TXT.stockLimit());
        return;
      }

      const title = decodeURIComponent(addBtn.dataset.title || "");
      const url = decodeURIComponent(addBtn.dataset.url || "");
      const image = decodeURIComponent(addBtn.dataset.image || "");
      const price = variant ? parseInt(variant.price || "0", 10) : 0;

      const existing = state.set.get(variantId);
      if (existing) {
        existing.qty += 1;
        state.set.set(variantId, existing);
      } else {
        state.set.set(variantId, { variantId, title, url, image, price, qty: 1 });
      }

      renderSet();
    }
  };

  const onSetClick = (e) => {
    const rm = e.target.closest(".js-remove");
    if (!rm) return;
    const id = parseInt(rm.dataset.variant || "0", 10);
    state.set.delete(id);
    renderSet();
  };

  // -------- Bindings --------
  if (els.modelSearch) {
    els.modelSearch.addEventListener("input", (e) => {
      state.search = e.target.value || "";
      renderModelChips();
    });
  }

  if (els.pillsWrap) {
    els.pillsWrap.addEventListener("click", (e) => {
      const btn = e.target.closest(".build-set__pill");
      if (!btn) return;
      state.category = btn.dataset.category;
      renderAll();
    });
  }

  if (els.onlyModel) {
    els.onlyModel.checked = !!state.onlyModel;
    els.onlyModel.addEventListener("change", (e) => {
      state.onlyModel = !!e.target.checked;
      renderAll();
    });
  }

  if (els.clearSet) {
    els.clearSet.addEventListener("click", () => {
      state.set.clear();
      renderSet();
    });
  }

  if (els.addSet) els.addSet.addEventListener("click", addSetFlow);

  if (els.grid) els.grid.addEventListener("click", onGridClick);
  if (els.setItems) els.setItems.addEventListener("click", onSetClick);

  const renderAll = () => {
    renderModelChips();
    renderPills();
    renderGrid();
    renderSet();
  };

  // -------- Boot --------
  buildIndexes();

  refreshCartQuantities().finally(() => {
    renderAll();
  });

  window.addEventListener("pageshow", () => {
    refreshCartQuantities();
  });
})();

/* === Ring Size Guide (Builder) === */
(function () {
  const root = document.querySelector(".build-set") || document.querySelector("[data-build-set]") || document;
  const modal = document.getElementById("BuildSetRingGuideModal");
  if (!modal) return;

  const closeBtn = modal.querySelector(".js-ring-guide-close");

  const getLocale = () => {
    const htmlLang = (document.documentElement.getAttribute("lang") || "").toLowerCase();
    const shopifyLocale =
      window.Shopify && (window.Shopify.locale || window.Shopify.language)
        ? String(window.Shopify.locale || window.Shopify.language).toLowerCase()
        : "";
    return (htmlLang || shopifyLocale || "ro").trim();
  };

  const isEnglish = () => {
    const loc = getLocale();
    return loc === "en" || loc.startsWith("en-");
  };

  function openModal() {
    modal.classList.add("is-open");
    modal.setAttribute("aria-hidden", "false");
    document.documentElement.classList.add("build-set--modal-open");
    document.body.classList.add("build-set--modal-open");
  }

  function closeModal() {
    modal.classList.remove("is-open");
    modal.setAttribute("aria-hidden", "true");
    document.documentElement.classList.remove("build-set--modal-open");
    document.body.classList.remove("build-set--modal-open");
  }

  if (closeBtn) closeBtn.addEventListener("click", closeModal);

  modal.addEventListener("click", (e) => {
    if (e.target === modal) closeModal();
  });

  document.addEventListener("keydown", (e) => {
    if (!modal.classList.contains("is-open")) return;
    if (e.key === "Escape") closeModal();
  });

  function ensureGuideLinks() {
    const linkText = isEnglish() ? "Ring size guide" : "Ghid de mărimi";

    const headers = document.querySelectorAll(
      ".build-set__variant-head, .build-set__variantHeader, .build-set__variant-header"
    );

    if (headers && headers.length) {
      headers.forEach((h) => {
        if (h.querySelector(".js-open-ring-guide")) return;

        const container = h.closest("div") || h.parentElement;
        const hasSelect = container ? container.querySelector("select") : h.querySelector("select");
        if (!hasSelect) return;

        const btn = document.createElement("button");
        btn.type = "button";
        btn.className = "build-set__size-guide-link js-open-ring-guide";
        btn.textContent = linkText;
        btn.addEventListener("click", openModal);
        h.appendChild(btn);
      });
      return;
    }

    const selects = document.querySelectorAll(".build-set select");
    selects.forEach((sel) => {
      const opts = Array.from(sel.querySelectorAll("option")).map((o) => (o.textContent || "").trim());

      const looksLikeVariant =
        opts.length > 0 &&
        opts.some((t) => /\d/.test(t)) &&
        !opts.every((t) => {
          const x = t.toLowerCase();
          return x === "select" || x === "selectează" || x === "selecteaza";
        });

      if (!looksLikeVariant) return;

      const parent = sel.parentElement;
      if (!parent) return;
      if (parent.querySelector(".js-open-ring-guide")) return;

      const btn = document.createElement("button");
      btn.type = "button";
      btn.className = "build-set__size-guide-link js-open-ring-guide";
      btn.textContent = linkText;
      btn.style.display = "inline-block";
      btn.style.marginTop = "6px";
      btn.addEventListener("click", openModal);

      parent.appendChild(btn);
    });
  }

  ensureGuideLinks();

  root.addEventListener("click", () => {
    window.requestAnimationFrame(ensureGuideLinks);
    window.setTimeout(ensureGuideLinks, 50);
  });

  const observer = new MutationObserver(() => ensureGuideLinks());
  observer.observe(document.body, { childList: true, subtree: true });
})();
/* Back to top */
(function () {
  var btn = document.querySelector('.js-back-top');
  if (!btn) return;
  window.addEventListener('scroll', function () {
    btn.classList.toggle('is-visible', window.scrollY > 400);
  }, { passive: true });
  btn.addEventListener('click', function () {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  });
})();